<template>
  <div>
    <v-row v-show="!isCardExpanded">
      <v-col cols="4">
        <management-card-group type="onTime" />
      </v-col>
      <v-col cols="4">
        <management-card-group type="critical" />
      </v-col>
      <v-col cols="4">
        <management-card-group type="late" />
      </v-col>
    </v-row>
    <v-row v-show="isCardExpanded" class="py-0 my-0">
      <v-col class="py-0 my-0"> <expanded-management-card /> </v-col
    ></v-row>
  </div>
</template>

<script>
import ManagementCardGroup from './ManagementCardGroup.vue';
import ExpandedManagementCard from './ExpandedManagementCard.vue';
import { ExpandedManagementCardHandler } from '@/store/modules/expandedManagementCard';
export default {
  components: {
    ManagementCardGroup,
    ExpandedManagementCard
  },
  computed: {
    isCardExpanded() {
      return ExpandedManagementCardHandler.getIsCardExpanded(this);
    }
  }
};
</script>

<style></style>
